import React from 'react';

import {Props, Type, Events, Notifications} from './model';
import {useSelector, useDispatch} from 'react-redux';
import {profileSettingsSelector} from '../../../../../../redux/selectors/profile';
import {useMemo} from 'react';
import {UpdateProfileSettingsRequestPayload} from '../../../../../../shared/models/api';
import {updateProfileSettings} from '../../../../../../redux/actions/profile';
import View from './view';
import {Notification} from '../../../../../../shared/constants/notificationTitle';

export const CheckBoxItem = (props: Props) => {
  const dispatch = useDispatch();

  const {type, notification, event, disabled} = props;
  if ((type === Type.event && !event) || (type === Type.notification && !notification)) {
    throw new Error('Добавьте данные');
  }

  const profileSettings = useSelector(profileSettingsSelector());
  const title = useMemo(() => {
    if (type === Type.event) {
      return Notification.event[event as Events];
    }
    if (type === Type.notification) {
      return Notification.notification[notification as Notifications];
    }
    return '';
  }, [type, notification, event]);

  if (!profileSettings) return null;

  const onClick = () => {
    const cloned = JSON.parse(JSON.stringify(profileSettings)) as UpdateProfileSettingsRequestPayload;
    if (type === Type.event) {
      if (event === Events.email) cloned.events.isEmail = !cloned.events.isEmail;
      if (event === Events.sms) cloned.events.isSms = !cloned.events.isSms;
    }
    if (type === Type.notification) {
      if (notification === Notifications.actionInfo) cloned.receiveInformationShares = !cloned.receiveInformationShares;
      if (notification === Notifications.personalOffer)
        cloned.receiveInformationOffers = !cloned.receiveInformationOffers;
      if (notification === Notifications.interview) cloned.receiveSurveyInformation = !cloned.receiveSurveyInformation;
    }

    dispatch(updateProfileSettings(cloned));
  };

  return (
    <View
      title={title}
      onClick={onClick}
      value={props.value}
      id={props.notification || props.event || ''}
      disabled={disabled}
    />
  );
};
